/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import Markdown from 'react-markdown';
import { Link } from 'react-router-dom';

interface FormattedDescriptionProps {
  text: string;
}

const FormattedDescription: React.FC<FormattedDescriptionProps> = ({
  text,
}) => {
  return (
    <Markdown
      components={{
        a: ({ children, href }) => (
          <Link to={href ?? '/'} target="_blank" rel="noopener noreferrer">
            {children}
          </Link>
        ),
      }}
    >
      {text}
    </Markdown>
  );
};

export default FormattedDescription;
